import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD, { managers, modules } from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import { getOneBundleByInstant } from "../../../BundleResourceConfig";
import { GAME_EVENT } from "./Enum";
import levelFindSpriteItemBase from "./levelFindSpriteItemBase";
import tipsPageSpNode from "./tipsPageSpNode";

const { ccclass, property, menu, disallowMultiple } = cc._decorator;

@ccclass
@disallowMultiple
export default class TipsPage extends BasePopUpLayer {

    @property({ type: cc.Node, displayName: "提示" })
    private tipNode: cc.Node = null;

    @property({ type: cc.Node, displayName: "答案" })
    private answerNode: cc.Node = null;

    @property({ type: cc.Node, displayName: "spScaleNode" })
    spScaleNode: cc.Node = null;

    tipsAndAnswer: string = "";

    autoShowSp: boolean = false;

    start () {
        this.OnPageOpen();
    }

    async OnPageOpen() {
        let tipAndAnswer: string = this._carryData.strHint;
        this.tipsAndAnswer = this._carryData.hintIcon;

        let tipsType = false;
        let tipFontLength = 10;
        let tipNode: cc.Node = this.tipNode.getChildByName("lbSmallLayout");
        if (tipsType) {
            tipNode = this.tipNode.getChildByName("lbHLayout");
        } else if ( tipAndAnswer.length > 40) {
            tipNode = this.tipNode.getChildByName("lbBigLayout");
            tipFontLength = 16;
        }

        tipNode.active = true;
        let needHang2: number = Math.ceil(tipAndAnswer.length / tipFontLength);
        for (let i = 0; i < tipNode.childrenCount; i++) {
            let aLabel = tipNode.getChildByName("Label" + i);
            aLabel.active = i < needHang2;
            let answerStr: string = "";
            for (let j = i * tipFontLength; j < i * tipFontLength + tipFontLength; j++) {
                if (tipAndAnswer[j])
                    answerStr += tipAndAnswer[j];
            }

            aLabel.getComponent(cc.Label).string = answerStr;
            if (i >= needHang2) {
                aLabel.active = false;
            } else {
                aLabel.active = true;
            }
        }

        let answerNode = this.answerNode.getChildByName("lbSmallLayout");
        if (true) {
            const sp = this.answerNode.getChildByName("mask").getChildByName("sp");
            sp.active = true;
            for (let i = 0; i < answerNode.childrenCount; i++) {
                let aLabel = answerNode.getChildByName("Label" + i);
                aLabel.active = false;
            } 
            let bundle = getOneBundleByInstant(this._carryData.bundleName);
            bundle.load(this.tipsAndAnswer, cc.SpriteFrame, (err, asset: cc.SpriteFrame) => {
                if (err) {
                    console.log("加载提示图片出错");
                    return;
                }
                sp.getComponent(cc.Sprite).spriteFrame = asset;

                let width = asset.getTexture().width;
                let height = asset.getTexture().height;

                let wRadio: number = 208 / width;
                let hRadio: number = 440 / height;



                let radio = 1;
                if (wRadio > hRadio) {
                    radio = wRadio;
                } else {
                    radio = hRadio;
                }

                sp.width = sp.width * radio;
                sp.height = sp.height * radio;

            });
        } 

        let bShowHint1: boolean = this._carryData.bShowHint1;
        let bShowHint2: boolean = this._carryData.bShowHint2;

        
        const ndContent = this.node.getChildByName("Content");
        ndContent.getChildByName('ad1').getChildByName('video').active = !bShowHint1;
        this.tipNode.opacity = bShowHint1 ? 255 : 0;
        ndContent.getChildByName("ad3").active = !bShowHint2 && !bShowHint1;
        ndContent.getChildByName("ad2").active = bShowHint1 && !bShowHint2;
        ndContent.getChildByName("ad2").getChildByName('video').active = !bShowHint2 && bShowHint1;
        this.answerNode.opacity = bShowHint2? 255 : 0;
        O1HD.emit(GAME_EVENT.GAME_PAUSE);
    }


    onClickTip() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let bShowHint1: boolean = this._carryData.bShowHint1;
        let bShowHint2: boolean = this._carryData.bShowHint2;
        let showHint1 = this._carryData.showHint1;
        if (bShowHint1) {
            showHint1 && showHint1();
            this.node.getChildByName("Content").getChildByName("ad1").active = false;
            this.tipNode.opacity = 255;
            return;
        }

        cc.game.pause();
        utilsModel.loadAndShowVideoAdTrans(() => {
            this.tipNode.opacity = 255;
            this.node.getChildByName("Content").getChildByName("ad1").active = false;
            this.node.getChildByName("Content").getChildByName("ad3").active = false;
            this.node.getChildByName("Content").getChildByName("ad2").active = true;
            this.node.getChildByName("Content").getChildByName("ad2").getChildByName('video').active = true;
            O1HD.emit(GAME_EVENT.ON_TIPS_GOT);
            this._carryData.bShowHint1 = true;
            showHint1 && showHint1();
            cc.game.resume();
        }, () => {
            cc.game.resume();
        }, () => {
            cc.game.resume();
        }, "看视频获取提示");
    }
 
    onClickAnswer() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let bShowHint1: boolean = this._carryData.bShowHint1;
        let bShowHint2: boolean = this._carryData.bShowHint2;
        if (!bShowHint1) {
            modules().uiControlModule.showMessageBox("请先解锁提示");
            return;
        }
        let showHint2 = this._carryData.showHint2;
        if (bShowHint2) {
            showHint2 && showHint2();
            this.answerNode.opacity = 255;
            this.node.getChildByName("Content").getChildByName("ad2").active = false;
            if (this.autoShowSp) {
                this.onShowSp(null, "answer");
            }
            return;
        }
        cc.game.pause();
        utilsModel.loadAndShowVideoAdTrans(() => {
            this.node.getChildByName("Content").getChildByName("ad2").active = false;
            O1HD.emit(GAME_EVENT.ON_ANSWER_GOT);
            this.answerNode.opacity = 255;
            showHint2 && showHint2();
            this._carryData.bShowHint2 = true;
            if (this.autoShowSp) {
                this.onShowSp(null, "answer");
            }
            cc.game.resume();
        }, () => {
            cc.game.resume();
        }, () => {
            cc.game.resume();
        }, "看视频获取答案");
    }

    onShowSp(e: cc.Event.EventTouch, type: string) {
        let spTexture: cc.SpriteFrame = null;
        switch (type) {
            case "tip": {
                spTexture = this.tipNode.getChildByName("mask").getChildByName("sp").getComponent(cc.Sprite).spriteFrame.clone();
                break;
            }
            case "answer": {
                let sp = this.answerNode.getChildByName("mask").getChildByName("sp").getComponent(cc.Sprite).spriteFrame;
                if (sp)
                    spTexture = sp.clone();
                break;
            }
        }
        if (spTexture) {
            this.spScaleNode.active = true;
            this.spScaleNode.opacity = 0;
            let spNode = this.spScaleNode.getChildByName("sp");
            spNode.setPosition(cc.v2(0, 0));
            spNode.getComponent(cc.Sprite).spriteFrame = spTexture;
            let width = spTexture.getTexture().width;
            let height = spTexture.getTexture().height;
            let canvasWidth = this.spScaleNode.width;
            let radio = canvasWidth / width;
            spNode.width = width * radio;
            spNode.height = height * radio;

            let isLayerUp = spNode.getComponent(levelFindSpriteItemBase).isLayerUp;

            const parentHeight = spNode.parent.getContentSize().height;
            const heights = (parentHeight / 2) - (spNode.height / 2);
            if (isLayerUp) {
                spNode.position = cc.v3(0, heights, 0);
            }
            this.spScaleNode.getChildByName("bg").active = true;
            cc.tween(this.spScaleNode).to(0.5, { opacity: 255 }).start();
        }
    }

    closeSpScale() {
        this.spScaleNode.active = false;
    }

    onClickCose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let onClose = this._carryData.onClose;
        onClose && onClose();
        this.destroyNode();
    }

    @property({ type: cc.Node, displayName: "spScaleNode" })
    answerScaleNode: cc.Node = null;

    answerNodeCopy: cc.Node = null;

    onAnswerClick() {
        this.answerNodeCopy = cc.instantiate(this.answerNode);
        this.answerScaleNode.addChild(this.answerNodeCopy);
        this.answerNodeCopy.scale = 2;
        let ts = this.answerNodeCopy.addComponent(tipsPageSpNode);
        this.answerNodeCopy.removeComponent(cc.Button);
        ts.tipsPage = this;
        ts.scaleMul = 0.2;
        ts.maxScale = 3;
        this.answerScaleNode.active = true;
        this.answerNodeCopy.setPosition(cc.v2(0, 0));
        this.answerScaleNode.getChildByName("bg").active = true;
        cc.tween(this.answerScaleNode).to(0.5, { opacity: 255 }).start();
    }

    closeAnswerScale() {
        this.answerNodeCopy && this.answerNodeCopy?.destroy();
        this.answerNodeCopy && this.answerNodeCopy?.removeFromParent();
        this.answerNodeCopy = null;
        this.answerScaleNode.active = false;
    }
}